var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 301.469,
    height: 155.873,
    viewBox: "0 0 301.469 155.873",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.507,
    y1: 0.124,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b7b7b",
    stopOpacity: 0.278
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.167,
    y1: 0.587,
    x2: 0.734,
    y2: 1.345,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e3e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.495,
    y1: 0.075,
    x2: 0.5,
    y2: 2.932,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b7b7b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.017,
    y1: 0.554,
    x2: -0.039,
    y2: 0.294,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7b7b7b",
    stopOpacity: 0.302
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.922,
    y1: 0.838,
    x2: 0.026,
    y2: -0.046,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.017,
    y1: 0.554,
    x2: 1.039,
    y2: 0.294,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.078,
    y1: 0.838,
    x2: 0.974,
    y2: -0.046,
    xlinkHref: "#linear-gradient-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8182",
    "data-name": "Group 8182",
    transform: "translate(-531.728 -463.127)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8613",
    "data-name": "Path 8613",
    d: "M-1743.963,2424.733c-11.92,22.75-124.912,153.5-149.746,153.5s-135.839-131.75-149-153.5",
    transform: "translate(2575.81 -1960.233)",
    stroke: "gray",
    strokeLinecap: "round",
    strokeWidth: 2,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10928",
    "data-name": "Path 10928",
    d: "M3540.068,645.846s-38.521-87.33-13.562-121.7h29.042C3555.893,525.75,3580.816,559.783,3540.068,645.846Z",
    transform: "translate(-2858.493 -29.5)",
    fill: "none",
    stroke: "#dbd8d8",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8146",
    "data-name": "Group 8146",
    transform: "translate(667.099 493.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10929",
    "data-name": "Path 10929",
    d: "M3540.366,646.385l15.6-123.617a297.133,297.133,0,0,1-29.993,0Z",
    transform: "translate(-3525.969 -522.524)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10927",
    "data-name": "Path 10927",
    d: "M3531.2,571.743H3550l5.961-48.976s-17.123.366-29.993,0Z",
    transform: "translate(-3525.969 -522.768)",
    fill: "#a8a8a8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_5419",
    "data-name": "Path 5419",
    d: "M87.834,2677.94s56.894,30.335,148.3,29.947c0,0,88.737,1.965,148.041-30.048Z",
    transform: "translate(446.579 -2213.34)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8180",
    "data-name": "Group 8180"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4039",
    "data-name": "Path 4039",
    d: "M309.191,2808.313,283.8,2775.985s-29.522,36.8-67.72,97.792l93.115,33.061v-98.524Z",
    transform: "translate(522.809 -2300.485)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10932",
    "data-name": "Path 10932",
    d: "M-6.8,4.456,43.943,36.032-10.325,6.979Z",
    transform: "translate(785 528)",
    fill: "url(#linear-gradient-5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8181",
    "data-name": "Group 8181",
    transform: "translate(534.101 475.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4039-2",
    "data-name": "Path 4039",
    d: "M216.077,2808.313l25.395-32.329s29.522,36.8,67.719,97.792l-93.114,33.061v-98.524Z",
    transform: "translate(-216.077 -2775.985)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10932-2",
    "data-name": "Path 10932",
    d: "M40.418,4.456-10.325,36.032,43.943,6.979Z",
    transform: "translate(13.382 52.5)",
    fill: "url(#linear-gradient-7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTail);
export default __webpack_public_path__ + "static/media/tail.2cd222885733c0b7e2a52d1c2bde1699.svg";
export { ForwardRef as ReactComponent };